"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MergeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6.5,3.79289322 L8.85355339,6.14644661 C9.04881554,6.34170876 9.04881554,6.65829124 8.85355339,6.85355339 C8.67998704,7.02711974 8.41056264,7.04640489 8.2156945,6.91140884 L8.14644661,6.85355339 L7,5.70689322 L7,7 C7,10.3137085 9.6862915,13 13,13 L13,14 C10.4537132,14 8.22496429,12.6404588 7.00005536,10.6076785 L7,15 L6,15 L6,5.70689322 L4.85355339,6.85355339 C4.67998704,7.02711974 4.41056264,7.04640489 4.2156945,6.91140884 L4.14644661,6.85355339 C3.97288026,6.67998704 3.95359511,6.41056264 4.08859116,6.2156945 L4.14644661,6.14644661 L6.5,3.79289322 Z" })));
};
MergeSmall.displayName = 'MergeSmall';
exports.default = MergeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MergeSmall.js.map